<template>
  <div class="mt-component-form">
    <vs-row class="my-4">
      <h5 style="align-self: center"><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto">
        <vs-button v-if="!isPrint && !readonly" class="" color="secondary" type="border" @click="handleAddRow">항목추가</vs-button>
        <vs-button v-if="!isPrint && !readonly" class="ml-4" color="secondary" @click="handleRemoveRow">선택삭제</vs-button>
      </div>
    </vs-row>

    <table>
      <colgroup>
        <col v-if="!isPrint" width="40" />
      </colgroup>
      <thead>
        <th v-if="!isPrint">
          <div class="flex items-center justify-center">
            <vs-checkbox v-if="!isPrint && !readonly" :value="allCheck" @click.native="onClickAllCheckbox" class="vscheck"></vs-checkbox>
          </div>
        </th>
        <th>날짜</th>
        <th>품명</th>
        <th>규격</th>
        <th>이월재고</th>
        <th>추가구입량</th>
        <th>불출량</th>
        <th>현재고</th>
      </thead>
      <tbody>
        <tr v-for="(item, item_i) in list" :key="item_i">
          <td v-if="!isPrint">
            <div class="flex items-center justify-center">
              <vs-checkbox v-if="!item.readonly && !readonly" v-model="checkIndexs" :vs-value="item.id" class="vscheck"></vs-checkbox>
            </div>
          </td>
          <td>
            <date-selector v-if="!isPrint" v-model="item.input1" class="w-full" :readonly="item.readonly || readonly"></date-selector>
            <p v-else class="print-input">{{ item.input1 }}</p>
          </td>
          <td>
            <ml-input v-if="!isPrint" v-model="item.input2" class="w-full" :readonly="item.readonly || readonly" />
            <p v-else class="print-input">{{ item.input2 }}</p>
          </td>
          <td>
            <ml-input v-if="!isPrint" v-model="item.input3" class="w-full" :readonly="item.readonly || readonly" />
            <p v-else class="print-input">{{ item.input3 }}</p>
          </td>
          <td>
            <comma-input v-if="!isPrint" v-model="item.input4" class="w-full" :readonly="item.readonly || readonly" />
            <p v-else class="print-input">{{ item.input4 }}</p>
          </td>
          <td>
            <comma-input v-if="!isPrint" v-model="item.input5" class="w-full" :readonly="item.readonly || readonly" />
            <p v-else class="print-input">{{ item.input5 }}</p>
          </td>
          <td>
            <comma-input v-if="!isPrint" v-model="item.input6" class="w-full" :readonly="item.readonly || readonly" />
            <p v-else class="print-input">{{ item.input6 }}</p>
          </td>
          <td>
            <comma-input v-if="!isPrint" item="1" class="w-full" readonly :value="(Number(item.input4) || 0) + (Number(item.input5) || 0) - (Number(item.input6) || 0)" />
            <span v-else class="print-input">{{ (Number(item.input4) || 0) + (Number(item.input5) || 0) - (Number(item.input6) || 0) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";
export default {
  name: "TableStock",
  components: { DateSelector },
  props: {
    title: String,
    isPrint: Boolean,
    readonly: Boolean,
    value: Array,
  },
  data() {
    return {
      list: this.value,
      checkIndexs: [],
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
    };
  },
  computed: {
    allCheck() {
      return 0 < this.list.length && this.list.length === this.checkIndexs.length;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    // 항목추가
    handleAddRow() {
      this.list.push({ id: ++this.numberId });
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => item.readonly || !this.checkIndexs.includes(item.id));
      this.checkIndexs = [];
    },

    // 일괄 체크
    onClickAllCheckbox() {
      if (this.allCheck) this.checkIndexs = [];
      else this.checkIndexs = this.list.map((_item, _index) => _item.id);
    },
  },
};
</script>
<style scoped lang="scss">
table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  &,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    padding: 15px 0;
    background: #f9f9f9;
  }

  td {
    text-align: center;
    padding: 4px;
  }
}

.vscheck::v-deep .vs-checkbox {
  margin-right: 0px;
}
</style>
